import parseAddresses, { type ParsedMailbox } from 'email-addresses';
import React, { Fragment, useMemo } from 'react';

import ParsedMailboxChip from './ParsedMailboxChip';

type Props = {
  text: string | null | undefined;
};

function getParsedMailboxes(text: string | null | undefined): string | ParsedMailbox[] {
  if (text === null || text === undefined || text.trim().length === 0) {
    return [];
  }

  try {
    const result = parseAddresses({ input: text, simple: false });
    if (!result) {
      return [];
    }
    const mailboxes: ParsedMailbox[] = [];
    result.addresses.forEach((v) => {
      if (v.type === 'mailbox') {
        return mailboxes.push(v);
      }
      return mailboxes.push(...v.addresses);
    });
    return mailboxes;
  } catch (e) {
    return text;
  }
}

export default function RecipientsChipsList({ text }: Props) {
  const results = useMemo(() => getParsedMailboxes(text), [text]);

  if (typeof results === 'string') {
    return <>{results}</>;
  }

  return (
    <>
      {results.map((k, i) => (
        <Fragment key={i}>
          {i === 0 ? null : ','}
          <ParsedMailboxChip mailbox={k} />
        </Fragment>
      ))}
    </>
  );
}
